import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { billingService } from '../services/billing';

/**
 * Lets admins through. Everyone else needs an active paid plan that includes `product`.
 * Otherwise they are sent back to pricing instead of the ERP pages.
 */
const RequirePaidProduct = ({ product, children }) => {
  const { user } = useAuth();
  const [allowed, setAllowed] = useState(user?.role === 'admin' ? true : null);

  useEffect(() => {
    if (user?.role === 'admin') {
      setAllowed(true);
      return undefined;
    }
    let mounted = true;
    billingService
      .getMyBilling()
      .then((data) => {
        if (!mounted) return;
        const plan = data?.plan;
        const products = plan?.products || [];
        setAllowed(plan?.status === 'active' && products.includes(product));
      })
      .catch(() => {
        if (mounted) setAllowed(false);
      });
    return () => {
      mounted = false;
    };
  }, [user?.role, product]);

  if (allowed === null) {
    return (
      <div style={{ padding: 48, textAlign: 'center', color: '#4B5468' }}>
        Checking your plan…
      </div>
    );
  }

  if (!allowed) {
    return <Navigate to="/pricing" replace />;
  }

  return children;
};

export default RequirePaidProduct;
